module.exports = __webpack_public_path__ + "static/media/tiktok.2fb90fc3.png";